var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.93738 12.5556V14.3333C9.93738 15.0406 9.65489 15.7189 9.15206 16.219C8.64923 16.719 7.96724 17 7.25613 17H3.68113C2.97002 17 2.28803 16.719 1.7852 16.219C1.28237 15.7189 0.999878 15.0406 0.999878 14.3333V3.66667C0.999878 2.95942 1.28237 2.28115 1.7852 1.78105C2.28803 1.28095 2.97002 1 3.68113 1H7.25613C7.96724 1 8.64923 1.28095 9.15206 1.78105C9.65489 2.28115 9.93738 2.95942 9.93738 3.66667V5.44444",
    stroke: "#607783",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.43738 8.57895H13.9999",
    stroke: "#607783",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.68738 11.9474L3.43738 8.57896L6.68738 5.21054",
    stroke: "#607783",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.312a81772ecfebcd98a319dd71f4ed60.svg";
export { ForwardRef as ReactComponent };